// extracted by mini-css-extract-plugin
export var center = "_20-2";
export var clickableRow = "_20-5";
export var expandedRow = "_20-7";
export var hoverable = "_20-4";
export var left = "_20-1";
export var right = "_20-3";
export var row = "_20-0";
export var selectedRow = "_20-6";
export var summaryRow = "_20-8";